import React from 'react';

const ImpressumPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Impressum</h1>

        <h2>Ayşegül Saraç</h2>
        <p>Remigiusstraße 39</p>
        <p>50937 Köln</p>

        <h2>Kontakt</h2>
        <p>Telefon: +49 (0) 15228301212</p>
        <p>E-Mail: <a href="mailto:info@aysegulsarac.com">info@aysegulsarac.com</a></p>

        <h2>Zuständige Aufsichtsbehörde</h2>
        <p>Gewerbemeldestelle Köln</p>
        <p>Gewerbenummer: GEWA10000350726</p>

        <h2>Umsatzsteuer-ID</h2>
        <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE369071970</p>
        <p>Als Kleinunternehmer im Sinne von § 19 Abs. 1 UStG wird die Umsatzsteuer nicht ausgewiesen.</p>

        <h2>Redaktionell verantwortlich</h2>
        <p>Ayşegül Saraç</p>

        <h2>Verbraucherstreitbeilegung/Universalschlichtungsstelle</h2>
        <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
      </div>
    </div>
  );
};

export default ImpressumPage;
